export default __webpack_public_path__ + "static/media/material-ui.ff3d60e0.svg";